export interface IAnimatedChar {
  char: string;
  /** Задержка пульса символа, секунды */
  delay: number;
}

const FIRST_CHAR_DELAY_S = 0.3;
const CHAR_DELAY_STEP_S = 0.025;

/**
 * Разбивает текст язычка на символы с нарастающей задержкой анимации «пульса»,
 * как в примере дизайнера: первый символ через 0,3 с, каждый следующий на 25 мс позже.
 */
export function splitToAnimatedChars(text: string): IAnimatedChar[] {
  return Array.from(text).map((char, index) => ({
    char,
    delay: Number((FIRST_CHAR_DELAY_S + CHAR_DELAY_STEP_S * index).toFixed(3)),
  }));
}
